import { useEffect, useState } from "react";
import { ArrowDown, ArrowUp, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MENU } from "@/lib/uiSettings";

const STARTS = [["/", "Databases (home)"], ...Object.values(MENU).map((m) => [m.to, m.label])];

export default function MenuTab({ ui, onSave }) {
  const [v, setV] = useState(ui);
  useEffect(() => { setV(ui); }, [ui]);
  const menu = v.menu;
  const setMenu = (m) => setV({ ...v, menu: m });
  const patch = (i, p) => setMenu(menu.map((m, j) => (j === i ? { ...m, ...p } : m)));
  const swap = (i, j) => { const m = [...menu]; [m[i], m[j]] = [m[j], m[i]]; setMenu(m); };

  return (
    <div className="max-w-3xl space-y-5" data-testid="menu-tab">
      <div className="border rounded-lg bg-card divide-y" data-testid="menu-items">
        {menu.map((m, i) => (
          <div key={m.key} className="flex flex-wrap items-center gap-3 p-3" data-testid={`menu-row-${m.key}`}>
            <div className="flex flex-col">
              <button onClick={() => swap(i, i - 1)} disabled={i === 0} className="text-muted-foreground hover:text-primary disabled:opacity-30" data-testid={`menu-up-${m.key}`} aria-label="Move up"><ArrowUp size={14} /></button>
              <button onClick={() => swap(i, i + 1)} disabled={i === menu.length - 1} className="text-muted-foreground hover:text-primary disabled:opacity-30" data-testid={`menu-down-${m.key}`} aria-label="Move down"><ArrowDown size={14} /></button>
            </div>
            <span className="w-36 text-sm text-muted-foreground">{MENU[m.key].label}</span>
            <Input className="h-8 flex-1 min-w-[160px]" maxLength={40} placeholder={`Name in menu (default: ${MENU[m.key].label})`} value={m.label}
              onChange={(e) => patch(i, { label: e.target.value })} data-testid={`menu-label-${m.key}`} />
            {m.key === "admin" ? <span className="text-xs text-muted-foreground w-20">Always shown</span> : (
              <label className="flex items-center gap-2 text-sm w-24 pr-1"><Switch checked={!m.hidden} onCheckedChange={(c) => patch(i, { hidden: !c })} data-testid={`menu-show-${m.key}`} /> {m.hidden ? "Hidden" : "Shown"}</label>
            )}
          </div>
        ))}
      </div>
      <div className="space-y-1.5 max-w-xs"><Label>Start page after signing in</Label>
        <Select value={v.start_page} onValueChange={(s) => setV({ ...v, start_page: s })}>
          <SelectTrigger data-testid="start-page-select"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-card">{STARTS.map(([to, l]) => <SelectItem key={to} value={to} data-testid={`start-opt-${to.replace(/\//g, "") || "home"}`}>{l}</SelectItem>)}</SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">Techs go to the start page only if they're allowed to use it.</p>
      </div>
      <Button onClick={() => onSave(v)} data-testid="menu-save"><Save size={14} /> Save menu</Button>
    </div>
  );
}
